// The drive-through confirmation displays run on LG NetCast TVs whose browser
// spoofs a Chrome 53 UA ("... (Linux; NetCast; U) ... SmartTV/6.0") over a
// much older real engine. These TVs DO run service workers — production
// router logs (2026-08-12) show ngsw on the TV background-prefetching both
// the es5 and es2015 bundle sets (~14MB) over the TV's single HTTP/2
// connection, starving the foreground page's own styles/scripts fetches and
// wedging boot. ngsw must therefore never be enabled for these devices on
// ANY route (they enter at /login-code, not /confirmation-display).
export function isLegacyTvUserAgent(ua: string): boolean {
  try {
    return /NetCast|SmartTV/i.test(ua || '');
  } catch (_) {
    return false;
  }
}

// Single decision point for ServiceWorkerModule's `enabled` flag:
// - never on legacy TVs (see above);
// - never on /confirmation-display (permanent kiosk sessions must not let an
//   old app shell survive deployments).
export function ngswEnabledForClient(ua: string, pathname: string): boolean {
  return !isLegacyTvUserAgent(ua)
    && (pathname || '').indexOf('/confirmation-display') !== 0;
}
